const KEY = "activeAccountId";

export const getActiveAccountId = () => localStorage.getItem(KEY);
export const setActiveAccountId = (id) => localStorage.setItem(KEY, String(id));
export const clearActiveAccountId = () => localStorage.removeItem(KEY);

// Full reload so no page keeps data from the previous account
export const switchAccount = (id) => {
  setActiveAccountId(id);
  window.location.assign("/Home");
};